import Page from './page';
import { trackPage } from './analytics-helper';

const fireImpressionFptiForChatLoadError = (link = '', hpid = '') => {
  const errorPageId = Page.getFptiIdForChatLoadError();
  if (errorPageId) {
    const options = {
      id: errorPageId,
    };

    if (link) {
      options.link = link;
    }

    if (hpid) {
      options.hpid = hpid;
    }
    trackPage(options);
    return true;
  }
  return false;
};

export default fireImpressionFptiForChatLoadError;
